export const version = 'kunde-v1.20.0-SNAPSHOT-6e5b69076276c98981699c8b7815e8dd9cb64435';